var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3608 12.4687L6.98584 1.98078C6.6759 1.8063 6.32015 1.7304 5.96598 1.7632C5.61182 1.796 5.27606 1.93595 5.00343 2.16438C4.7308 2.39282 4.53425 2.6989 4.43997 3.04186C4.34569 3.38482 4.35815 3.74836 4.47569 4.08406L7.82584 14L4.47569 23.917C4.38245 24.1809 4.35387 24.4633 4.39234 24.7405C4.43081 25.0178 4.53521 25.2817 4.69678 25.5102C4.85835 25.7388 5.07237 25.9252 5.3209 26.0539C5.56942 26.1827 5.84519 26.2499 6.12506 26.25C6.42913 26.2494 6.72788 26.1702 6.99241 26.0203L25.3587 15.5148C25.6296 15.3631 25.8552 15.142 26.0124 14.8742C26.1697 14.6065 26.2528 14.3017 26.2534 13.9912C26.254 13.6807 26.1719 13.3756 26.0156 13.1073C25.8593 12.839 25.6345 12.6171 25.3641 12.4644L25.3608 12.4687ZM6.12506 24.5C6.12553 24.4956 6.12553 24.4912 6.12506 24.4869L9.37788 14.875H15.7501C15.9821 14.875 16.2047 14.7828 16.3688 14.6187C16.5329 14.4546 16.6251 14.2321 16.6251 14C16.6251 13.7679 16.5329 13.5454 16.3688 13.3813C16.2047 13.2172 15.9821 13.125 15.7501 13.125H9.37788L6.13163 3.5175C6.13055 3.51131 6.12832 3.50537 6.12506 3.5L24.5001 13.9814L6.12506 24.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c3b1803f981a09ca27c30272009f72f4.svg";
export { ForwardRef as ReactComponent };